
    var riot = require('riot')
    
import marked from "marked"
riot.tag2('riot-md', '', '', '', function(opts) {
    const self = this
    marked.setOptions({
      breaks: true
    })

    if(opts.type == "html") {
      self.root.innerHTML = opts.str
    } else {
      self.root.innerHTML = marked(opts.str)
    }
});
    
  


// WEBPACK FOOTER //
// ./_src/js/riot/riot-md.tag